import { LineMark } from "@/ds";

import { GanttTip } from "@/shared/components/gantt-tip";
import type { ObraLineMarkViewModel } from "./types-gantt-obra-line";
import styles from "./gantt-obra-line.module.scss";

/**
 * Linha fina da etapa Obra (Figma: visão por Obras), sobre o `LineMark` do DS, com o card do tooltip: "Obra" e as
 * datas acima (barra larga) ou ao lado (estreita).
 */
export function ObraLineMarkView({ line, layout, wide, anchorProps, tip }: ObraLineMarkViewModel) {
  return (
    <>
      <LineMark
        position={{ start: line.left, end: line.left + line.width }}
        tone="primary"
        past={line.past}
        layout={layout}
        testId="gantt-obra-line"
        tabIndex={0}
        {...anchorProps}
        label={
          wide ? (
            <span className={styles.head}>
              <span>{line.start}</span>
              <span>Obra</span>
              <span>{line.end}</span>
            </span>
          ) : (
            <>
              Obra
              <span className={styles.dateBefore}>{line.start}</span>
              <span className={styles.dateAfter}>{line.end}</span>
            </>
          )
        }
      />
      <GanttTip tip={tip} />
    </>
  );
}
